<template>
    <div class="page-profile__header">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="profile-heading__user profile-heading__user-volunteer d-flex">

                        <div class="profile-heading__user-header">
                            <div class="profile-heading__user-image">
                                <img :src="`/storage${data.avatar.path.replace('original', 'avatar')}`" :alt="data.name" v-if="data.avatar">
                                <span v-text="getUserPM(data.name)"></span>
                            </div>
                            <span class="profile-heading__user--verified-icon" v-if="data.is_verified">
                                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.9363 23.9159L9.82825 24.7678C8.22178 25.4171 6.39141 24.6589 5.71454 23.0639L4.82634 20.9709C4.67399 20.6118 4.38816 20.326 4.02914 20.1737L1.93611 19.2855C0.341093 18.6086 -0.417071 16.7782 0.232162 15.1718L1.0841 13.0637C1.23024 12.7021 1.23024 12.2979 1.0841 11.9363L0.232162 9.82825C-0.417071 8.22178 0.341093 6.39141 1.93611 5.71454L4.02914 4.82634C4.38816 4.67399 4.67399 4.38816 4.82634 4.02914L5.71454 1.93611C6.39141 0.341093 8.22178 -0.417071 9.82825 0.232162L11.9363 1.0841C12.2979 1.23024 12.7021 1.23024 13.0637 1.0841L15.1718 0.232162C16.7782 -0.417071 18.6086 0.341093 19.2855 1.93611L20.1737 4.02914C20.326 4.38816 20.6118 4.67399 20.9709 4.82634L23.0639 5.71454C24.6589 6.39141 25.4171 8.22178 24.7678 9.82825L23.9159 11.9363C23.7698 12.2979 23.7698 12.7021 23.9159 13.0637L24.7678 15.1718C25.4171 16.7782 24.6589 18.6086 23.0639 19.2855L20.9709 20.1737C20.6118 20.326 20.326 20.6118 20.1737 20.9709L19.2855 23.0639C18.6086 24.6589 16.7782 25.4171 15.1718 24.7678L13.0637 23.9159C12.7021 23.7698 12.2979 23.7698 11.9363 23.9159Z" fill="#91DA66"/>
                                    <path d="M9.16287 11.4621L7.71213 12.9129C7.59497 13.03 7.59498 13.22 7.71213 13.3371L11.0379 16.6629C11.155 16.78 11.345 16.78 11.4621 16.6629L17.2879 10.8371C17.405 10.72 17.405 10.53 17.2879 10.4129L15.8371 8.96213C15.72 8.84497 15.53 8.84497 15.4129 8.96213L11.25 13.125L9.58713 11.4621C9.46997 11.345 9.28003 11.345 9.16287 11.4621Z" fill="white"/>
                                </svg>
                            </span>
                            <div class="profile-heading__user-loyalty" v-if="data.loyalty_level">
                                {{$store.getters.t('user_heading_loyalty_member')}}
                            </div>
                        </div>

                        <div class="profile-heading__user-info">

                            <div class="profile-heading__user-info-heading d-flex">
                                <div class="profile-heading__user-info-name">
                                    {{data.name}}<template v-if="data.city">, <span class="profile-heading__user-info-location">{{data.city.name}}</span></template>
                                </div>
                            </div>


                            <div class="profile-heading__user-pets d-flex">

                                <div class="profile-heading__user-pets-item" v-if="data.public_phone || data.organization">
                                    <a :href="`tel:${data.public_phone}`" v-if="data.public_phone">{{data.public_phone}}</a>
                                    <span v-if="data.organization">{{$store.getters.t('user_heading_organization')}} <a :href="`/organizations/${data.organization.id}`">{{data.organization.name}}</a></span>
                                </div>
                                <div class="profile-heading__user-pets-item profile-heading__user-pets-actual">
                                    {{
                                        (data && data.total_donated_pets_count || 0) +
                                        (data && data.processed_donorships_count || 0)
                                    }} {{$store.getters.t('user_dashboard_meta_animals_helped')}}
                                </div>
                                <div class="profile-heading__user-pets-item profile-heading__user-pets-arranged">
                                    {{ data.actual_self_pets_count }} {{$store.getters.t('user_about_current')}}
                                </div>
                                <div class="profile-heading__user-pets-item profile-heading__user-pets-ads">
                                    {{ facilitiesSum || 0 }} {{$store.getters.t('user_heading_ads')}}
                                </div>
                            </div>

                            <div class="profile-heading__user-donations">
                                {{$store.getters.t('user_heading_donated')}}
                                <span class="profile-heading__user-donations-sum">{{data['donated_by_user']}} EUR</span>
                                <span v-if="data.organization">({{$store.getters.t('user_heading_by_organization')}} <span class="profile-heading__user-donations-sum">{{data['donated_by_organization']}} EUR</span>)</span>
                            </div>
                            <div class="profile-heading__user-donations" v-if="typeof +data['spent_by_user'] === 'number'">
                                {{$store.getters.t('user_heading_spent')}}
                                <span class="profile-heading__user-donations-sum">{{data['spent_by_user']}} EUR</span>
                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>

import {mapGetters} from 'vuex'

export default {
    props: ['data'],
    name: "UserHeading",

    methods:{

        getUserPM(name){
            let nameArray = name.trim().split(' ');
            return nameArray[0][0] + ((nameArray[1]) ? nameArray[1][0] : '') + '';
        },

    },

    computed:{

        ...mapGetters({
           stateFacilities: 'getFacilities'
        }),

        facilitiesSum(){

            let sum = 0;

            if( this.stateFacilities ){

                for( const _f  in  this.stateFacilities){
                    sum += +this.stateFacilities[ _f ] || 0
                }

            }

            return sum

        }
    }


}
</script>

<style lang="scss" scoped>

</style>
